import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const http = inject(HttpClient);
  const router = inject(Router);

  if (req.url.includes('/refresh-token')) {
    const refreshToken = localStorage.getItem('refresh-token');
    if (!refreshToken) {
      return throwError(() => new Error('No refresh token available'));
    }
    return next(req.clone({
      setHeaders: { Authorization: `Bearer ${refreshToken}` }
    }));
  }

  const token = localStorage.getItem('token');
  const authReq = token ? req.clone({
    setHeaders: { Authorization: `Bearer ${token}` }
  }) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isRefreshing) {
        isRefreshing = true;
        const refreshToken = localStorage.getItem('refresh-token');

        if (!refreshToken) {
          router.navigate(['/login']);
          return throwError(() => new Error('No refresh token available'));
        }

        return http.post<{access_token: string}>(
          `${environment.apiUrl}/refresh-token`,
          {},
          { headers: { Authorization: `Bearer ${refreshToken}` } }
        ).pipe(
          switchMap(response => {
            isRefreshing = false;
            localStorage.setItem('token', response.access_token);
            return next(req.clone({
              setHeaders: { Authorization: `Bearer ${response.access_token}` }
            }));
          }),
          catchError(refreshError => {
            isRefreshing = false;
            localStorage.removeItem('token');
            localStorage.removeItem('refresh-token');
            router.navigate(['/login']);
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};